import React from 'react';
import { Link } from 'react-router-dom';
import { Autoplay, Navigation, Pagination } from "swiper/modules"
import { Swiper, SwiperSlide } from "swiper/react"
import teamImg1 from '../../assets/images/team/team-1-1.jpg';
import teamImg2 from '../../assets/images/team/team-1-2.jpg';
import teamImg3 from '../../assets/images/team/team-1-3.jpg';

const swiperOptions = {
    modules: [Autoplay, Pagination, Navigation],
    slidesPerView: 2,
    spaceBetween: 30,
    speed: 2000,
    autoplay: {
        delay: 9000,
        disableOnInteraction: false,
    },
    loop: true,

    // Navigation
    navigation: {
        nextEl: ".swiper-button-prev1",
        prevEl: ".swiper-button-next1"
    },

    // Pagination
    pagination: {
        el: ".swiper-dot-style1",
        type: "bullets",
        clickable: true
    },

    breakpoints: {
        0: {
            spaceBetween: 0,
            slidesPerView: 1
        },
        375: {
            spaceBetween: 0,
            slidesPerView: 1
        },
        575: {
            spaceBetween: 0,
            slidesPerView: 1
        },
        768: {
            spaceBetween: 30,
            slidesPerView: 1
        },
        992: {
            spaceBetween: 30,
            slidesPerView: 2
        },
        1200: {
            spaceBetween: 30,
            slidesPerView:3
        },
        1320: {
            spaceBetween: 30,
            slidesPerView:3
        }
    }
}
export default function TeamSlider() {
    return (
        <> 
        
        <Swiper {...swiperOptions} className="thm-swiper__slider swiper-container">
            <div className="swiper-wrapper">

              {
                [1,2,3,4,5,6,7,8,9,10].map((item,index)=>(
                    <SwiperSlide className="swiper-slide">
                    <div className="team-one__single">
    
                        <div className="team-one__content p-2">
                        <h3 className="team-one__title">
                            <Link to="/team-details">Heading {item}</Link>
                        </h3>
                        <p className="team-one__sub-title">Lorem ipsum dolor sit amet consectetur adipisicing elit. Quisquam, quos.</p>
    
                        <span type='button' className=' text-dark'>
                            <Link className='text-dark' to="/team-details">Read More </Link>
                            <i style={{fontSize: '14px'}} className="icon-angle-left "></i>
                        </span>
                        </div>
                    </div>
                    </SwiperSlide>
                ))
              }
            </div>
        </Swiper>
      </>
      
    )
}
